<template>
  <div class="submitSuccess">
    <div class="submitSuccess-container">
      <div class="submitSuccess-container-img">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="submitSuccess-container-text">
        <p class="submitSuccess-container-text-submit">恭喜您，资料提交成功</p>
        <p class="submitSuccess-container-text-suc">
          您的资料已成功提交，公司宝审核专员会进行初步审核，请返回服务单关注最新状态。
        </p>
      </div>
    </div>
    <div class="serviceListBtn">
      <button @click="$router.replace('/icpmyorder/purchased')">服务单</button>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.commit('alfillmaterials/changeActivedIndex', 30);
  },
};
</script>

<style lang="scss">
.submitSuccess {
  width: 100%;
  background: white;
  padding: 121px 318px 498px;
  margin-bottom: 60px;
  .submitSuccess-container {
    display: flex;
    justify-content: center;
    margin-bottom: 86px;
    .submitSuccess-container-img {
      width: 75px;
      height: 73px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 50px;
      color: #ff8a01;
    }
    .submitSuccess-container-text {
      flex: 1;
      padding: 0 12px;
      .submitSuccess-container-text-submit {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 28px;
        margin-bottom: 23px;
      }
      .submitSuccess-container-text-suc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
        line-height: 17px;
      }
    }
  }
  .serviceListBtn {
    display: flex;
    justify-content: center;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      border: none;
      color: white;
      cursor: pointer;
    }
  }
}
</style>
